module.exports = __webpack_public_path__ + "assets/img/Bus-stop.b973d8ed.svg";